//
//
//
//
//
//

export default {
  props: {
    color: {
      type: String,
      default: '#FD595E',
    },
  },
}
